import { memo } from "react";

import { PlayerDetailViewProps } from "@/types/playerDetailTypes";
import AddToWatchlistActionsheet from "@/components/organisms/AddToWatchlistActionsheet";
import PlayerDetailCenter from "@/components/organisms/PlayerDetailCenter";
import PlayerDetailLeft from "@/components/organisms/PlayerDetailLeft";
// import "./styles.css";

import { Stack } from "@/components/atoms/Stack";
import { Watchlist } from "@/generated/graphql";

/**
 * Pure view component for player detail
 * @param props - Component props including player data and handlers
 */
const PlayerDetailView = (props: PlayerDetailViewProps) => (
  <>
    <Stack className="flex-1">
      <Stack direction="horizontal" className="flex-1">
        <PlayerDetailLeft
          loading={props.loading}
          loadWatchList={props.loadWatchList}
          onCallbackOpen={props.onCallbackOpen}
          refreshing={props.isRefreshing}
          players={props.players}
          watchlists={props.watchlists}
          onLoadMore={props.onLoadMore}
          onRefresh={props.onRefresh}
          onDragEnd={props.onDragEnd}
          activeWatchlist={props.activeWatchlist}
        />
        <PlayerDetailCenter
          playerId={props.playerId}
          activeWatchList={props.activeWatchlist as Watchlist}
          onAddPlayer={props.onAddPlayer}
          pauseQuery={props.pauseDetailQuery}
        />
      </Stack>
      {props.showActionSheet && props.playerDetail && (
        <AddToWatchlistActionsheet
          item={props.playerDetail}
          showActionsheet={props.showActionSheet}
          onClose={props.onClose}
          onAddPress={props.onAddPlayer}
          onAddWatchlistPress={props.onAddWatchlistPress}
          loading={props.loading}
          isPlayerInAnyWatchlist={!!props.playerDetail?.isWatchedByCurrentUser}
          promptRef={props.promptRef}
          isDark={props.isDark}
        />
      )}
    </Stack>
  </>
);

PlayerDetailView.displayName = "PlayerDetailView";

export default memo(PlayerDetailView);
